import io from 'socket.io-client'
import store from '../store'
import { showToast, refreshGold, showNotice } from '@/utils/tool'
import { amountFormat } from '@/utils/filters'
import i18n from '@/i18n'

export default {
  install(Vue, options) {
    Vue.prototype.$socket = {
      client: null,
      init: function() {
        if (this.client) {
          return
        }

        const socketioUrl = process.env.VUE_APP_ENV === 'production'
          ? process.env.VUE_APP_NOTIFY // 正式站
          : process.env.VUE_APP_NOTIFY_DEV // 測試站

        console.log('Connecting to Socket.IO server:', socketioUrl)

        try {
          this.client = io(socketioUrl, {
            transports: ['websocket'],
            withCredentials: false,
            reconnectionAttempts: 3, // 1 次主連線 + 3 次重試
            reconnectionDelay: 1000,
            timeout: 5000
          })

          const client = this.client

          // 添加連接錯誤處理
          this.client.on('connect_error', (error) => {
            console.error('Socket.IO connection error:', error)
          })

          this.client.on('connect_timeout', () => {
            console.error('Socket.IO connection timeout')
          })

          this.client.on('error', (error) => {
            console.error('Socket.IO error:', error)
          })

          // socketio內建event
          // 建立連線
          this.client.on('connect', function() {
            console.log('Socket connected with ID:', client.id)

            // 連接後進行認證
            if (store.getters.token) {
              console.log('Authenticating with token')
              client.emit('auth', { token: store.getters.token })
            }
          })

          // 認證成功回調
          this.client.on('authed', function() {
            console.log('Socket authentication successful')
          })

          // 重新連線
          this.client.on('reconnect', function(attemptNumber) {
            console.log('Socket reconnected after', attemptNumber, 'attempts')
            // 重連後重新認證
            if (store.getters.token) {
              client.emit('auth', { token: store.getters.token })
            }
          })

          // 斷線重連
          this.client.on('disconnect', function(reason) {
            console.log('Socket disconnected. Reason:', reason)
          })

          // 關閉重連
          this.client.on('close', function(event) {
            console.log('Socket closed')
          })

          // 接收聊天訊息
          this.client.on('chat_recv', function(message) {
            console.log('Chat message received:', message)
          })

          // 新增 notify 事件監聽 - 接收伺服器通知回調
          this.client.on('notify', function(data) {
            console.log('Notification received:', data)
            const notificationData = data && (data.data || data)
            const notificationMsg = notificationData && notificationData.msg !== undefined ? notificationData.msg : data && data.msg
            // 確認回調格式是否正確
            if (!notificationData || !notificationData.cmd || !notificationData.params || !notificationData.user_id || notificationMsg === null) {
              console.error('Invalid notification format:', data)
              return
            }
            // 處理不同類型的通知
            const notificationType = notificationData.cmd
            switch (notificationType) {
              case 'first_deposit': {
                const { code, activate_no } = notificationData.params
                const toastMessage = i18n.t('Bao.notify_first_bonus', { code })
                if (activate_no !== 0) {
                  showToast(toastMessage, null, true, false)
                  refreshGold('multi_wallet')
                }
                break
              }
              case 'deposit': {
                const { amount } = notificationData.params
                const toastMessage = `${amount} ${i18n.t('Bao.notify_socket')}`
                showToast(toastMessage, null, true, false)
                refreshGold('multi_wallet')

                break
              }
              case 'bonus_wallet_transfer_to_target_wallet': {
                // [金額+幣別]已經從贈金錢包轉到[目標]錢包
                const { target_wallet_amount, target_wallet_type } = notificationData.params

                // 找錢包資訊
                const targetWallet = store.getters.walletInfo.find(w => w.wallet_type === target_wallet_type)

                const formattedAmount = target_wallet_type === 'main' ? amountFormat(target_wallet_amount, 2) : amountFormat(target_wallet_amount, 6)
                const valueWithCurrency = target_wallet_type === 'main' ? `${formattedAmount} JPY` : `${formattedAmount} ${target_wallet_type}`
                const target = target_wallet_type === 'main' ? i18n.t('Bao.main') : `${target_wallet_type}`
                const noticMessage = i18n.t('Bao.notify_transfer', {
                  value: valueWithCurrency,
                  target
                })

                if (store.state.app.inGameId !== null) {
                  showNotice(noticMessage, function() {
                    store.commit('SET_WALLET_SWITCH_REQUEST', {
                      wallet: targetWallet,
                      game: store.state.app.currentGame })
                  }, true, false, i18n.t('Bao.ok_btn'))
                } else {
                  showToast(noticMessage, null, true, false)
                }
                refreshGold('multi_wallet')
                break
              }
              case 'before_bet_module_fail': {
                const { error_code } = notificationData.params
                if (error_code === 'bonus_wallet_amount_limit') {
                  showToast(i18n.t('Bao.notify_bonus_wallet_amount_limit'))
                }
                break
              }
              case 'coupon_dispatch': {
                const { amount, currency, wallet_type } = notificationData.params
                const walletMap = {
                  main: i18n.t('Bao.main'),
                  bonus: i18n.t('Bao.bonus_detail')
                }

                // BONUS 錢包派發＝入金不要ボーナス（註冊體驗金），用專屬文案；JPY 金額不帶小數
                const isBonusWallet = wallet_type === 'bonus'
                const formattedAmount = currency === 'JPY' ? amountFormat(amount, isBonusWallet ? 0 : 2) : amountFormat(amount, 6)
                const walletType = walletMap[wallet_type] || wallet_type
                const toastMessage = isBonusWallet
                  ? i18n.t('Bao.notify_register_coupon', { amount: formattedAmount, currency })
                  : i18n.t('Bao.notify_coupon', { amount: formattedAmount, currency, target: walletType })
                showToast(toastMessage, null, true, false)
                refreshGold('multi_wallet')
                break
              }
              case 'rebate_dispatch_approved': {
                const { amount, currency } = notificationData.params
                const formattedAmount = currency === 'JPY' ? amountFormat(amount, 2) : amountFormat(amount, 6)
                const toastMessage = i18n.t('Bao.notify_rebate_approved', { amount: formattedAmount, currency })
                showToast(toastMessage, null, true, false)
                refreshGold('multi_wallet')
                break
              }
              case 'rebate_dispatch_received': {
                const { amount, currency, wallet_type } = notificationData.params
                const walletMap = {
                  main: i18n.t('Bao.main'),
                  bonus: i18n.t('Bao.bonus_detail')
                }
                const formattedAmount = currency === 'JPY' ? amountFormat(amount, 2) : amountFormat(amount, 6)
                const walletType = walletMap[wallet_type] || wallet_type
                const toastMessage = i18n.t('Bao.notify_rebate_received', { amount: formattedAmount, currency, target: walletType })
                showToast(toastMessage, null, true, false)
                refreshGold('multi_wallet')
                break
              }
              case 'upgrade_approved':
              case 'birthday_approved':
              case 'weekly_approved':
              case 'monthly_approved':
              case 'upgrade_received':
              case 'birthday_received':
              case 'weekly_received':
              case 'monthly_received': {
                const { amount, currency, wallet_type } = notificationData.params
                const [prefix, status] = notificationType.split('_')
                const vipBonusMap = {
                  upgrade: i18n.t('Bao.vip_bonus_type_upgrade'),
                  birthday: i18n.t('Bao.vip_bonus_type_birthday'),
                  weekly: i18n.t('Bao.vip_bonus_type_weekly'),
                  monthly: i18n.t('Bao.vip_bonus_type_monthly')
                }
                const walletMap = {
                  main: i18n.t('Bao.main'),
                  bonus: i18n.t('Bao.bonus_detail')
                }

                const vipBonusName = vipBonusMap[prefix]
                const formattedAmount = currency === 'JPY' ? amountFormat(amount, 2) : amountFormat(amount, 6)
                let toastMessage
                if (status === 'approved') {
                  toastMessage = i18n.t('Bao.notify_vip_approved', {
                    bonusType: vipBonusName,
                    amount: formattedAmount,
                    currency
                  })
                } else {
                  const walletType = walletMap[wallet_type] || wallet_type
                  toastMessage = i18n.t('Bao.notify_vip_received', {
                    bonusType: vipBonusName,
                    amount: formattedAmount,
                    currency,
                    target: walletType
                  })
                }
                showToast(toastMessage, null, true, false)
                refreshGold('multi_wallet')
                break
              }

              default:
                console.log(`Unknown notification command: ${notificationData.cmd}`)
                break
            }
          })
        } catch (e) {
          console.error('Failed to initialize socket connection:', e)
        }
      },
      reinit: function() {
        console.log('Reinitializing socket connection')

        if (this.client) {
          this.client.close()
          this.client = null
        }

        this.init()
      },
      close: function() {
        console.log('Closing socket connection')

        if (this.client) {
          this.client.close()
          this.client = null
        }
      }
    }
  }
}
